export default "__VITE_ASSET__CWwxbKb5__"